/*=========================================================================================
  File Name: module-auth-getters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getUserInfo: function(state) {
		return state.User;
	},
	getAccessToken: function(state) {
		return state.AccessToken;
	}
};
